export default "__VITE_ASSET__BXthMCA4__"